import styled from "styled-components";

// Text for a screen reader only: it keeps its place in the reading order but
// takes no room on the page.
export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;
